{
  "blocks": [
    {
      "id": "program-genetic-screening",
      "kind": "program",
      "tags": ["genetic-screening", "both-partners", "testing"],
      "title": "Genetic Screening",
      "subtitle": "Carrier screening to identify inherited condition risks",
      "icon": "🧬",
      "body": {
        "duration": "4–8 weeks",
        "includes": [
          "Expanded carrier panel for both partners (200+ conditions)",
          "Blood or saliva sample collection",
          "Genetic counselor consultation",
          "Actionable guidance if both partners carry the same condition",
          "PGT-M recommendations if applicable"
        ],
        "priceRange": {
          "low": 250,
          "high": 1500
        },
        "currency": "USD",
        "status": "coming-soon",
        "forWhom": "both",
        "category": "assessment",
        "moduleIds": ["module-genetic-carrier"],
        "phases": [
          {
            "title": "Screening",
            "description": "Carrier panel for both partners",
            "moduleIds": ["module-genetic-carrier"]
          }
        ],
        "steps": [
          {
            "title": "Sample collection",
            "description": "Blood draw or saliva kit for each partner. At a lab or at home."
          },
          {
            "title": "Lab processing",
            "description": "Genetic analysis takes 2–4 weeks. Screens 200+ conditions."
          },
          {
            "title": "Counseling",
            "description": "Genetic counselor reviews findings and discusses implications."
          }
        ]
      },
      "sources": [
        {
          "title": "Carrier screening for genetic conditions: ACOG committee opinion",
          "journal": "Obstetrics & Gynecology",
          "year": 2023,
          "evidenceLevel": "expert-opinion"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "program-genetic-screening",
      "to": "module-genetic-carrier",
      "type": "contains"
    }
  ],
  "localeVariants": []
}
